import "regenerator-runtime/runtime.js";
import Vue from 'vue';
import App from './components/app.vue';

new Vue({
    el : "#app",

    components : { App }
});